import { createFileRoute } from '@tanstack/react-router';
import { RewardsPage } from '@/features/rewards/rewards-page';

export const Route = createFileRoute('/_authenticated/rewards')({
  component: RewardsPage,
});
